import type { AccountingObjectType } from 'core/accounting/domain/AccountingObjectType'
import type { Mode } from 'core/domain/Mode'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentChargesRepository } from '../infra/ShipmentChargesRepository'

export type GetShipmentChargesFactoryDependencies = {
  repository: ShipmentChargesRepository
}

export function getPriceItemTypesFactory({ repository }: GetShipmentChargesFactoryDependencies) {
  return function getPriceItemTypes(
    mode: Mode,
    usage: AccountingObjectType,
    config?: { signal?: AbortSignal }
  ) {
    return repository.getPriceItemTypes(mode, usage, config)
  }
}

export function getPriceItemTypes(
  mode: Mode,
  usage: AccountingObjectType,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const get = getPriceItemTypesFactory({ repository })

  return get(mode, usage, config)
}
